
import * as permissionsMapper from "models/mapper/permissionsResponse"
import * as constants from "lib/api/constants";
import { ApiPromiseClient } from "../apiClient/ApiClient";
import { PermissionsResponse, PermissionsResponseDTO } from "auth";


export async function Permissions(
    api: ApiPromiseClient
): Promise<PermissionsResponse> {
    const dto = await api.Get<PermissionsResponseDTO>(constants.Paths().permissions)
    return permissionsMapper.New().Map(dto)
}
